export { default } from './DisclaimerF1';
